import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { CreatePspTagModel, PspTagItem } from '@/models/psp-tag/psp-tag.model';

export default class CreatePspTagRequest extends ApiResourceMethod<PspTagItem> {
  public perform(payload: CreatePspTagModel): Promise<PspTagItem> {
    return this.performer.requestWithMapper(
      { params: payload },
      (payload: BaseResponse<PspTagItem>): PspTagItem => payload.data,
    );
  }
}
